
import { useState } from 'react';

export default function WhatsAppButton() {
  const [showOptions, setShowOptions] = useState(false);

  return (
    <>
      <button
        onClick={() => setShowOptions(!showOptions)}
        className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-40 bg-green-500 hover:bg-green-600 text-white w-12 h-12 sm:w-16 sm:h-16 rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer"
        aria-label="WhatsApp"
      >
        <i className="ri-whatsapp-line text-xl sm:text-3xl"></i>
      </button>

      {showOptions && (
        <>
          <div 
            className="fixed inset-0 z-30 bg-black/20"
            onClick={() => setShowOptions(false)}
          ></div>
          <div className="fixed bottom-20 sm:bottom-28 right-4 sm:right-6 z-40 bg-white rounded-xl shadow-2xl p-3 sm:p-5 w-64 sm:w-80 border border-gray-200">
            <div className="flex items-center justify-between mb-3">
              <h3 className="font-bold text-gray-900 text-sm sm:text-lg">Contáctanos</h3>
              <button 
                onClick={() => setShowOptions(false)}
                className="text-gray-400 hover:text-gray-600 cursor-pointer"
              >
                <i className="ri-close-line text-xl sm:text-2xl"></i>
              </button>
            </div>
            <div className="space-y-2 sm:space-y-3">
              <a
                href="https://wa.me/51994719367?text=Hola,%20necesito%20información%20sobre%20perforación%20de%20pozos"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 sm:gap-3 p-2.5 sm:p-3 bg-green-50 hover:bg-green-100 rounded-lg transition-all cursor-pointer"
              >
                <div className="w-9 h-9 sm:w-12 sm:h-12 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-whatsapp-line text-lg sm:text-2xl text-white"></i>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-gray-900 text-xs sm:text-base">WhatsApp 1</p>
                  <p className="text-xs sm:text-sm text-gray-600">+51 994 719 367</p>
                </div>
              </a>
              <a
                href="https://wa.me/51953183017?text=Hola,%20necesito%20información%20sobre%20perforación%20de%20pozos"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 sm:gap-3 p-2.5 sm:p-3 bg-green-50 hover:bg-green-100 rounded-lg transition-all cursor-pointer"
              >
                <div className="w-9 h-9 sm:w-12 sm:h-12 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-whatsapp-line text-lg sm:text-2xl text-white"></i>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-gray-900 text-xs sm:text-base">WhatsApp 2</p>
                  <p className="text-xs sm:text-sm text-gray-600">+51 953 183 017</p>
                </div>
              </a>
            </div>
          </div>
        </>
      )}
    </>
  );
}
